import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("mm_user");
    if (raw) {
      const u = JSON.parse(raw);
      if (u?.league_name) config.headers["X-League-Name"] = u.league_name;
    }
  } catch (e) {
    // ignore localStorage errors
  }
  return config;
});

// Auto-clear stale sessions on 401 (user deleted) or 403 suspended (admin disabled account)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const detail = String(error?.response?.data?.detail || "").toLowerCase();
    const isSuspended = status === 403 && detail.includes("suspended");
    if (status === 401 || isSuspended) {
      try { localStorage.removeItem("mm_user"); } catch (e) { /* ignore */ }
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.replace("/");
      }
    }
    return Promise.reject(error);
  }
);
